import { BadgeDisplayProps } from '@event/types';
import { DefaultBadge } from '@levelSystem/components/badges';
import { Tooltip } from '@mui/material';
import { capitalizeFirstLetter, capitalizeWords, parseISODuration } from '@utils/common';
import { formatDuration } from 'date-fns';

export const BadgeDisplay = ({ badges, visibleBadgeCount = 3 }: BadgeDisplayProps) => {
    // Array from because the badges array is frozen when passed to this component
    const sortedBadges = Array.from(badges).sort((a, b) => b.level_badge.level.value - a.level_badge.level.value);
    const visibleBadges = sortedBadges.splice(0, visibleBadgeCount);

    return (
        <div className="flex items-center gap-[5px]">
            {visibleBadges.map((badge, index) => {
                const duration = !!badge.timeframe
                    ? capitalizeWords(formatDuration(parseISODuration(badge.timeframe)))
                    : null;

                const badgeName = capitalizeFirstLetter(badge.level_badge.badge.name);
                const badgeLevel = capitalizeFirstLetter(badge.level_badge.level.name);

                return (
                    <Tooltip
                        className="z-10 w-fit"
                        key={index}
                        title={`${badgeLevel} | ${badgeName} ${duration ? `| ${duration}` : ''}`}
                        arrow
                        placement={index === badges.length - 1 ? 'right' : 'bottom'}
                    >
                        <span>
                            <div className="flex items-center justify-center size-10 cursor-pointer">
                                {badge.level_badge.image ? (
                                    <img
                                        src={badge.level_badge.image}
                                        alt={badgeName}
                                        className="size-10 object-contain rounded-full"
                                        onError={(e) => {
                                            const target = e.target as HTMLImageElement;
                                            target.style.display = 'none';
                                        }}
                                    />
                                ) : (
                                    <DefaultBadge level={badge.level_badge.level.value} className="size-10" />
                                )}
                            </div>
                        </span>
                    </Tooltip>
                );
            })}
            {sortedBadges.length > 0 && (
                <Tooltip
                    className="z-10 w-fit"
                    title={
                        <div className="grid grid-cols-3 gap-2 p-2 m-0">
                            {sortedBadges.map((badge, index) => {
                                return (
                                    <div key={index} className="flex flex-col items-center gap-1 m-0 p-0">
                                        <div className="flex items-center justify-center">
                                            {badge.level_badge.image ? (
                                                <img
                                                    src={badge.level_badge.image}
                                                    alt={capitalizeFirstLetter(badge.level_badge.badge.name)}
                                                    className="size-10 object-contain rounded-full"
                                                    onError={(e) => {
                                                        const target = e.target as HTMLImageElement;
                                                        target.style.display = 'none';
                                                    }}
                                                />
                                            ) : (
                                                <DefaultBadge
                                                    level={badge.level_badge.level.value}
                                                    className="size-10"
                                                />
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    }
                    arrow
                    placement="bottom"
                >
                    <span>
                        <div className="flex items-center justify-center w-10 h-10 bg-blue-100 border border-blue-200 rounded-full text-xs font-medium text-blue-600 cursor-pointer hover:bg-blue-200 transition-colors">
                            +{sortedBadges.length}
                        </div>
                    </span>
                </Tooltip>
            )}
        </div>
    );
};
